// extracted by mini-css-extract-plugin
export default {"parchmentContainer":"Parchment_parchmentContainer__YfA2x","parchmentContent":"Parchment_parchmentContent__9Blvd","parchment":"Parchment_parchment__yQ4vz"};